import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSearchStyle0 = cosmosIconCss;

const CosmosIconSearch = /*@__PURE__*/ proxyCustomElement(class CosmosIconSearch extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '206ce908f59414e089ce4f196a0977d264b37729', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a3892c6d4ecea88ffdd9ea868a65471c97995520', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7cf9345cd1b9b1ebb23f1fb9afa02d89a3b5175d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 3a6 6 0 1 0 0 12A6 6 0 0 0 9 3Zm0 1.5A4.5 4.5 0 1 1 4.5 9 4.51 4.51 0 0 1 9 4.5Zm5.825 10.683a.5.5 0 0 0 0 .707l3.295 3.295a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707l-3.295-3.295a.5.5 0 0 0-.707 0l-.354.354Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSearchStyle0; }
}, [1, "cosmos-icon-search", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-search"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-search":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSearch);
            }
            break;
    } });
}

export { CosmosIconSearch as C, defineCustomElement as d };
